import { withRouter } from 'react-router-dom';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { connect } from 'react-redux';

import DiscoverAlbumFolderSuccess from '../../components/discover/DiscoverAlbumFolderSuccess';
import { MeQuery } from '../../graphql/queries/account';
import { AlbumFolderWithCreatorBrandDetails } from '../../graphql/queries/album-folder';

const withUser = graphql(MeQuery, {
  props: ({ data }) => ({
    user: data.me,
  }),
});

const mapStateToProps = ({ discoverAlbumFolder }) => ({
  identities: discoverAlbumFolder.identities,
  purchasedSubscription: discoverAlbumFolder.purchasedSubscription,
});

const withAlbumFolderData = graphql(AlbumFolderWithCreatorBrandDetails, {
  options: ({ match }) => ({
    variables: {
      id: match.params.albumFolderId,
    },
  }),
  props: ({ data: { albumFolder, loading } }) => ({
    albumFolder,
    loading,
  }),
  skip: ({ match }) => !match.params.albumFolderId,
});

export default compose(
  withRouter,
  withUser,
  connect(mapStateToProps),
  withAlbumFolderData,
)(DiscoverAlbumFolderSuccess);
